export const FACILITY_NAMES: { [key: string]: string } = {
  "11": "Probation (Regular)",
  "12": "Probation (Shock)",
  "13": "Probation (Misdemeanant)",
  "15": "Sex Offender Cond. Disch. Supv.",
  "19": "Probation (ISC)",
  "20": "Misdemeanor Intensive Program",
  "21": "Misdemeanant (ISC)",
  "22": "Sex Offender Postincarceration Supervision",
  "23": "Postincarceration Supervision",
  "24": "Mandatory Reentry Supervision",
  "30": "PRE-TRIAL DIVERSION",
  "100": "Pulaski",
  "101": "Robertson",
  "102": "Rockcastle",
  "103": "Rowan",
  "104": "Russell",
  "105": "Scott",
  "106": "Shelby",
  "107": "Simpson",
  "108": "Spencer",
  "109": "Taylor",
  "110": "Todd",
  "111": "Trigg",
  "112": "Trimble",
  "113": "Union",
  "114": "Warren",
  "115": "Washington",
  "116": "Wayne",
  "117": "Webster",
  "118": "Whitley",
  "119": "Wolfe",
  "120": "Woodford",
  "121": "Out-Of-State",
  "999": "Unknown",
  "741328": "Hope Center of Moreh",
  "INCARCERATED INMATES": "INCARCERATED INMATES",
  "Death Row Inmates": "Death Row Inmates",
  "Escaped Inmates": "Escaped Inmates",
  "COMMUNITY SUPERVISION OFFENDERS": "COMMUNITY SUPERVISION OFFENDERS",
  "PROBATION OFFENDERS": "PROBATION OFFENDERS",
  "PAROLE OFFENDERS": "PAROLE OFFENDERS",
  "02": "Parole (ISC)",
  "03": "Parole",
  "Absconded Probation & Parole Offenders": "Absconded Probation & Parole Offenders",
  "AB": "Absconded",
  "AC": "Roederer Assessment Cntr",
  "UN": "Inactive",
  "IN": "Incarcerated",
  "OS": "Out to Other State",
  "XX": "Sealed/Expunged or Pardoned",
  "Z9": "Unknown",
  "PR": "PRISON",
  "BF": "Reception (Assessment) Center",
  "B1": "KY DOC Prison",
  "B4": "Private Prison",
  "CS": "COMMUNITY SERVICE",
  "B8": "County Jail (CI/CD/CC)",
  "BU": "Halfway House",
  "PP": "SUPERVISION",
  "D3": "District Office",
  "D4": "Field Office",
  "BW": "Recovery Kentucky",
  "T1": "Home Incarceration Program (HIP)",
  "CO": "Assigned to Central Office",
  "BA": "Blackburn Assessment",
  "KCIWA": "KCIW Assessment",
  "RCA": "Ross- Cash Assessment Center",
  "WKCCA": "WKCC Assessment Center",
  "BCFC": "Bell County Forestry Camp",
  "BCC": "Blackburn Corr. Complex",
  "CKMCC": "Central Kentucky Medical Correctional Complex",
  "EKCC": "Eastern KY Corr. Complex",
  "GRCC": "Green River Corr. Complex",
  "KSP": "Kentucky State Penitentiary",
  "KSR": "Kentucky State Reformatory",
  "KCIW": "KY Corr. Inst. for Women",
  "KCPC": "KY Corr. Psychiatric Cntr",
  "LSCC": "Little Sandy Corr. Complex",
  "LLCC": "Luther Luckett Corr. Complex",
  "NTC": "Northpoint Training Center",
  "RCC": "Roederer Corr. Complex",
  "RC": "Ross- Cash Center",
  "SSCC": "Southeast State Corr. Complex",
  "WKCC": "Western KY Corr. Complex",
  "DBCDC": "Daniel Boone Career Dev. Cntr(closed)",
  "FCDC": "Frankfort Career Dev. Cntr(closed)",
  "FCF": "Frenchburg Corr. Facility(closed)",
  "HCFC": "Harlan County Forestry Camp(closed)",
  "RCCUnit5": "RCC SAP(closed)",
  "LAC": "Lee Adjustment Center",
  "MAC": "Marion Adjustment Center(closed)",
  "OCCC": "Otter Creek Corr. Cntr(closed)",
  "Y001": "Adair County Jail",
  "AYDC": "Adair Youth Development Center",
  "Y002": "Allen County Detention Center",
  "Y004": "Ballard County Detention Center",
  "Y005": "Barren County Detention Center",
  "Y007": "Bell County Detention Center",
  "Y008": "Boone County Jail",
  "Y009": "Bourbon County Regional Jail",
  "Y010": "Boyd County Detention Center",
  "BRJDC": "Boyd Regional Juvenile Detention Center",
  "Y011": "Boyle County Detention Center",
  "BRRJDC": "Breathitt Regional Juvenile Detention Center",
  "Y014": "Breckinridge County Jail",
  "Y015": "Bullitt County Detention Center",
  "Y016": "Butler County Jail",
  "Y017": "Caldwell County Jail",
  "Y018": "Calloway County Jail",
  "Y019": "Campbell County Detention Center",
  "CRJDC": "Campbell Regional Juvenile Detention Center",
  "Y021": "Carroll County Det. Cntr",
  "Y022": "Carter County Det. Cntr",
  "Y023": "Casey County Det. Cntr",
  "Y024": "Christian County Jail",
  "Y025": "Clark County Detention Center",
  "Y026": "Clay County Detention Center",
  "Y027": "Clinton County Jail",
  "Y028": "Crittenden County Detention Center",
  "Y030": "Daviess County Det. Cntr",
  "Y033": "Estill County Jail",
  "Y034": "Fayette County Det. Cntr",
  "FRJDC": "Fayette Regional Juvenile Detention Center",
  "Y036": "Floyd County Detention Center",
  "Y037": "Franklin County Regional Jail",
  "Y038": "Fulton County Detention Center",
  "Y041": "Grant County Detention Center",
  "Y042": "Graves County Jail",
  "Y043": "Grayson County Detention Center",
  "GRYDC": "Green River Youth Detention center",
  "Y045": "Greenup County Detention Center",
  "Y047": "Hardin County Detention Center",
  "Y048": "Harlan County Detention Center",
  "Y050": "Hart County Jail",
  "Y051": "Henderson County Detention Center",
  "Y053": "Hickman County Jail",
  "Y054": "Hopkins County Jail",
  "Y055": "Jackson County Detention Center",
  "Y057": "Jessamine County Detention Center",
  "Y058": "Johnson County Jail",
  "Y059": "Kenton County Det. Cntr",
  "Y061": "Knox County Detention Center",
  "LCYDC": "Lake Cumberland Youth Development Center",
  "Y062": "Larue County Detention Center",
  "Y063": "Laurel County Detention Center",
  "Y066": "Leslie County Detention Center",
  "Y067": "Letcher County Jail",
  "Y068": "Lewis County Jail",
  "Y069": "Lincoln County Jail",
  "Y071": "Logan County Detention Center",
  "Y056": "Louisville Metro Department of Corrections",
  "LRJDC": "Louisville Regional Juvenile Detention Center",
  "Y076": "Madison County Detention Center",
  "Y078": "Marion County Detention Center",
  "Y079": "Marshall County Detention Center",
  "Y081": "Mason County Det. Cntr",
  "MYDC": "Mayfield Youth Development Center",
  "Y073": "McCracken County Jail",
  "MRJDC": "McCracken Regional Juvenile Detention Cetner",
  "Y074": "McCreary County Jail",
  "Y082": "Meade County Detention Center",
  "Y086": "Monroe County Jail",
  "Y087": "Montgomery County Jail",
  "MHYDC": "Morehead Youth Development Center",
  "Y089": "Muhlenberg County Detention Center",
  "Y090": "Nelson County Jail",
  "NKYDC": "Northern Kentucky Youth Development Center",
  "Y092": "Ohio County Detention Center",
  "Y093": "Oldham County Detention Center",
  "Y096": "Pendleton County Jail",
  "Y097": "Perry County Jail",
  "Y098": "Pike County Detention Center",
  "Y099": "Powell County Detention Center",
  "Y100": "Pulaski County Detention Center",
  "Y102": "Rockcastle County Detention Center",
  "Y103": "Rowan County Detention Center",
  "Y104": "Russell County Detention Center",
  "Y105": "Scott County Detention Center",
  "Y106": "Shelby County Detention Center",
  "Y107": "Simpson County Jail",
  "Y108": "Spencer County Jail",
  "Y109": "Taylor County Detention Center",
  "Y065": "Three Forks Regional Jail",
  "Y110": "Todd County Jail",
  "Y114": "Warren County Jail",
  "WRJDC": "Warren Regional Juvenile Detention Center",
  "Y116": "Wayne County Detention Center",
  "Y117": "Webster County Jail",
  "Y118": "Whitley County Det. Cntr",
  "Y120": "Woodford County Detention Center",
  "WYDC": "Woodsbend Youth Development Center",
  "Y003": "Anderson County Jail(closed)",
  "Y006": "Bath County Jail(closed)",
  "Y012": "Bracken County Jail(closed)",
  "Y013": "Breathitt County Jail(closed)",
  "Y020": "Carlisle County Jail(closed)",
  "Y029": "Cumberland County Jail(closed)",
  "Y031": "Edmonson County Jail(closed)",
  "Y032": "Elliott County Jail(closed)",
  "Y035": "Fleming County Jail(closed)",
  "Y039": "Gallatin County Jail(closed)",
  "Y040": "Garrard County Jail(closed)",
  "Y044": "Green County Jail(closed)",
  "Y046": "Hancock County Jail(closed)",
  "Y049": "Harrison County Jail(closed)",
  "Y052": "Henry County Jail(closed)",
  "Y060": "Knott County Jail(closed)",
  "Y064": "Lawrence County Jail(closed)",
  "Y070": "Livingston County Jail(closed)",
  "Y072": "Lyon County Jail(closed)",
  "Y077": "Magoffin County Jail(closed)",
  "Y080": "Martin County Jail(closed)",
  "Y075": "McLean County Jail(closed)",
  "Y083": "Menifee County Jail(closed)",
  "Y084": "Mercer County Jail(closed)",
  "Y085": "Metcalfe County Jail(closed)",
  "Y088": "Morgan County Jail(closed)",
  "Y091": "Nicholas County Jail(closed)",
  "Y999": "Other (Unknown)(closed)",
  "Y094": "Owen County Jail(closed)",
  "Y095": "Owsley County Jail(closed)",
  "Y101": "Robertson County Jail(closed)",
  "Y111": "Trigg County Jail(closed)",
  "Y112": "Trimble County Jail(closed)",
  "Y113": "Union County Jail(closed)",
  "Y115": "Washington County Jail(closed)",
  "Y119": "Wolfe County Jail(closed)",
  "H150": "Ball-Quantrell Jones Hope Center for Women",
  "H146": "Bluegrass Career Development Center",
  "R150": "Brighton Recovery Center for Women",
  "R155": "Center Point Recovery Center",
  "H156": "Chestnut House",
  "R157": "Chrysalis House",
  "H147": "CTS-Russell",
  "R162": "Cumberland Hope",
  "H123": "Dismas Charities, Diersen",
  "H133": "Dismas Charities, Lexington",
  "H124": "Dismas Charities, Louisville",
  "H126": "Dismas Charities, Owensboro",
  "H135": "Dismas Charities, Portland",
  "H125": "Dismas Charities, St. Ann",
  "H129": "Dismas Charities, St. Patrick",
  "R153": "Genesis Recovery Center",
  "H153": "George Privett Center for Men",
  "R164": "Grateful Live Center",
  "H151": "Healing Place",
  "H159": "Healing Place for Men",
  "R160": "Healing Place of Campbellsville",
  "R159": "Hickory Hills Recovery Center",
  "H155": "Jacobs House",
  "H127": "KCI Paducah",
  "R152": "Liberty Place Recovery Center for Women",
  "R161": "MARC",
  "R151": "Owensboro Regional Recovery Center",
  "H149": "Salvation Army",
  "R154": "Sky Hope Recovery Center",
  "H154": "The Burns M. Brady Center",
  "R165": "Trilogy Center for Women",
  "H152": "VOA Halfway House",
  "H142": "WestCare - Ashcamp",
  "H160": "Westcare - Lookout",
  "R156": "Women's Addiction Recovery Manor (WARM)",
  "H148": "805 Mary Street(closed)",
  "H137": "Crown Services(closed)",
  "H130": "Dismas Charities, Owensboro Annex(closed)",
  "H138": "Dougherty House(closed)",
  "H143": "Hope Center for Men(closed)",
  "R158": "Renaissance House(closed)",
  "H145": "St. Andrews(closed)",
  "H122": "Transitions, Ashland(closed)",
  "H136": "Transitions, Droege(closed)",
  "H140": "Transitions, Two Rivers(closed)",
  "H134": "Transitions, W.R.A.P.(closed)",
  "H128": "Transitions, York Street(closed)",
  "H144": "VOA Halfway Back Program(closed)",
  "R100": "Brighton Center for Women (Florence)",
  "R0012": "Centerpoint Recovery Center (RKY)",
  "R101": "Cumberland Hope Community Ctr for Women (Evarts)",
  "R0014": "Genesis Recovery Center",
  "R105": "Grateful Life Center for Men (Erlanger)",
  "R0015": "Healing Place of Campbellsville",
  "R110": "Hickory Hill Recovery Center",
  "R102": "Liberty Place for Women (Richmond)",
  "R120": "Men's Addiction Recovery Center (MARC)",
  "R106": "Morehead Inspiration Center for Men (Morehead)",
  "R108": "Owensboro Regional Recovery Center",
  "R111": "Sky Hope",
  "R103": "Trilogy Center for Women (Hopkinsville)",
  "R104": "Women's Addiction Recovery Manor (Henderson)",
  "R001": "Brighton Center(closed)",
  "R109": "Center Point Recovery Center for Men(closed)",
  "R121": "Genesis Recovery Kentucky Center(closed)",
  "R0013": "Hickory Hill Recovery Center(closed)",
  "R107": "Taylor County Community Hope(closed)",
  "D01DO": "District 01 - Mayfield, Graves County",
  "D02DO": "District 02 - Hopkinsville, Christian County",
  "D03DO": "District 03 - Bowling green, Warren County",
  "D04DO": "District 04 - Louisville, Jefferson County",
  "D05DO": "District 05 - Elizabethtown, Hardin County",
  "D06DO": "District 06 - Danville, Boyle County",
  "D07DO": "District 07 - Bellevue, Campbell County",
  "D08DO": "District 08 - Richmond, Madison County",
  "D09DO": "District 09 - Lexington, Fayette County",
  "D10DO": "District 10 - London, Laurel County",
  "D11DO": "District 11 - Prestonsburg, Floyd County",
  "D12DO": "District 12 - Frankfort, Franklin County",
  "D13DO": "District 13 - Owensboro, Daviess County",
  "D14DO": "District 14 - Versailles, Woodford County",
  "D15DO": "District 15 - Catlettsburg, Boyd County",
  "D16DO": "District 16 - Louisville, Jefferson County",
  "D17DO": "District 17 - Louisville, Jefferson County",
  "D18DO": "District 18 - Louisville, Jefferson County",
  "D19DO": "District 19 - Louisville, Unknown County",
  "D20DO": "District 20 - Somerset, Pulaski County",
  "DO46": "MIP Cases - Louisville",
  "D21DO": "District 21(closed) - Louisville, Jefferson County",
  "D06F1": "Bardstown Office - Nelson County",
  "D01F1": "Benton Office - Marshall County",
  "D06F2": "Campbellsville Office - Taylor County",
  "D08F1": "Campton Office - Wolfe County",
  "D12F1": "Carrollton Office - Carroll County",
  "D03F1": "Columbia Office - Adair County",
  "D14F1": "Cynthiana Office - Harrison County",
  "D07FL": "Florence Office - Boone County",
  "D02F1": "Franklin Office - Simpson County",
  "D03F2": "Glasgow Office - Barren County",
  "D13F1": "Greenville Office - Muhlenberg County",
  "D10F1": "Harlan Office - Harlan County",
  "D11F2": "Hazard Office - Perry County",
  "D13F2": "Henderson Office - Henderson County",
  "D08F2": "Irvine Office - Estill County",
  "D12F2": "LaGrange Office - Oldham County",
  "D14F2": "Lancaster Office - Garrard County",
  "D05F1": "Leitchfield Office - Grayson County",
  "D02F2": "Madisonville Office - Hopkins County",
  "D10F2": "Manchester Office - Clay County",
  "D01F3": "Mayfield Office - Graves County",
  "D15F3": "Maysville Office - Mason County",
  "D20F2": "Monticello Office - Wayne County",
  "D08F3": "Morehead Office - Rowan County",
  "D13F3": "Morganfield Office - Union County",
  "D08F5": "Mt. Sterling Office - Montgomery County",
  "D01F4": "Murray Office - Calloway County",
  "D11F4": "Paintsville Office - Johnson County",
  "D11F5": "Pikeville Office - Pike County",
  "D10F3": "Pineville Office - Bell County",
  "D01F5": "Princeton Office - Caldwell County",
  "D02F3": "Russellville Office - Logan County",
  "D15F5": "Sandy Hook Office - Elliott County",
  "D12F3": "Shelbyville Office - Shelby County",
  "D05F2": "Shepherdsville Office - Bullitt County",
  "D11F6": "Whitesburg Office - Letcher County",
  "D20F1": "Williamsburg Office - Whitley County",
  "D01F2": "Fulton Office(temp. closed) - Fulton County",
  "D15F1": "Grayson Office(closed) - Carter County",
  "D15F2": "Greenup Office(closed) - Greenup County",
  "D11F3": "Hindman Office(closed) - Floyd County",
  "D12F4": "Lawrenceburg Office(closed) - Anderson County",
  "D08F4": "Richmond Office(closed) - Madison County",
  "063054": "Home Incarceration Program (HIP)",
  "ISC00": "Interstate Compact",
  "0060139": "Apprehended by Another Jurisdiction",
  "ISC01": "Released To Other Agency",
  "0099999": "UNKNOWN",
  "001": "Adair",
  "002": "Allen",
  "003": "Anderson",
  "004": "Ballard",
  "005": "Barren",
  "006": "Bath",
  "007": "Bell",
  "008": "Boone",
  "009": "Bourbon",
  "010": "Boyd",
  "011": "Boyle",
  "012": "Bracken",
  "013": "Breathitt",
  "014": "Breckinridge",
  "015": "Bullitt",
  "016": "Butler",
  "017": "Caldwell",
  "018": "Calloway",
  "019": "Campbell",
  "020": "Carlisle",
  "021": "Carroll",
  "022": "Carter",
  "023": "Casey",
  "024": "Christian",
  "025": "Clark",
  "026": "Clay",
  "027": "Clinton",
  "028": "Crittenden",
  "029": "Cumberland",
  "030": "Daviess",
  "031": "Edmonson",
  "032": "Elliott",
  "033": "Estill",
  "034": "Fayette",
  "035": "Fleming",
  "036": "Floyd",
  "037": "Franklin",
  "038": "Fulton",
  "039": "Gallatin",
  "040": "Garrard",
  "041": "Grant",
  "042": "Graves",
  "043": "Grayson",
  "044": "Green",
  "045": "Greenup",
  "046": "Hancock",
  "047": "Hardin",
  "048": "Harlan",
  "049": "Harrison",
  "050": "Hart",
  "051": "Henderson",
  "052": "Henry",
  "053": "Hickman",
  "054": "Hopkins",
  "055": "Jackson",
  "056": "Jefferson",
  "057": "Jessamine",
  "058": "Johnson",
  "059": "Kenton",
  "060": "Knott",
  "061": "Knox",
  "062": "Larue",
  "063": "Laurel",
  "064": "Lawrence",
  "065": "Lee",
  "066": "Leslie",
  "067": "Letcher",
  "068": "Lewis",
  "069": "Lincoln",
  "070": "Livingston",
  "071": "Logan",
  "072": "Lyon",
  "076": "Madison",
  "077": "Magoffin",
  "078": "Marion",
  "079": "Marshall",
  "080": "Martin",
  "081": "Mason",
  "073": "McCracken",
  "074": "McCreary",
  "075": "McLean",
  "082": "Meade",
  "083": "Menifee",
  "084": "Mercer",
  "085": "Metcalfe",
  "086": "Monroe",
  "087": "Montgomery",
  "088": "Morgan",
  "089": "Muhlenberg",
  "090": "Nelson",
  "091": "Nicholas",
  "092": "Ohio",
  "093": "Oldham",
  "094": "Owen",
  "095": "Owsley",
  "096": "Pendleton",
  "097": "Perry",
  "098": "Pike",
  "099": "Powell",
  "American Indian/Alaskan Native": "American Indian/Alaskan Native",
  "Asian or Pacific Islander": "Asian or Pacific Islander",
  "Bi-Racial": "Bi-Racial",
  "Black": "Black",
  "White": "White"
};

export function getLocationDisplay(location: any): string {
  if (!location) {
    return 'Unknown';
  }
  if (typeof location === 'object') {
    const locId = location.locationId;
    if (locId && FACILITY_NAMES[locId]) {
      return FACILITY_NAMES[locId];
    }
    return location.name || location.docCode || 'Unknown';
  }
  return FACILITY_NAMES[location] || location;
}